import { render } from "./qysds.vue?vue&type=template&id=ec8616c4&scoped=true"
import script from "./qysds.vue?vue&type=script&lang=js"
export * from "./qysds.vue?vue&type=script&lang=js"

import "./qysds.vue?vue&type=style&index=0&id=ec8616c4&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8616c4"]])

export default __exports__